/* eslint-disable object-shorthand */

export const PACKAGE_BUILD_DATE = '2026-10-27T13:25:38.019Z';
export const PACKAGE_NAME = '@invision/authentication';
export const PACKAGE_VERSION = '4.0.0-2680998';

export default {
  PACKAGE_BUILD_DATE: PACKAGE_BUILD_DATE,
  PACKAGE_NAME: PACKAGE_NAME,
  PACKAGE_VERSION: PACKAGE_VERSION
};
